import { useFeatureFlagContext } from '../../../../../Context/FeatureFlagContext';
import { getSelectOptions } from './utils';

import {
  CAMPAIGN_TRIGGER,
  RECIPIENT,
  RECIPIENT_TYPES,
  TRIGGER_TYPES,
} from './constants';

export const useFeatureFlaggedOptions = ({ recipient }) => {
  const {
    isAiEmailTriggerEnabled,
    isConfigurableStaleTriggerEnabled,
    isResidentDripCampaignEnabled,
  } = useFeatureFlagContext();

  const getTriggerOptions = getSelectOptions(CAMPAIGN_TRIGGER);
  const recipientOptions = getSelectOptions(RECIPIENT);

  const filterOptions = (option) => {
    switch (option.value) {
      case RECIPIENT_TYPES.RESIDENT:
        return isResidentDripCampaignEnabled;
      case TRIGGER_TYPES.AI_EMAIL:
        return isAiEmailTriggerEnabled;
      case TRIGGER_TYPES.CONFIGURABLE_STALE:
        return isConfigurableStaleTriggerEnabled;
      case TRIGGER_TYPES.MOVE_IN_DATE:
        return isResidentDripCampaignEnabled;
      default:
        return true;
    }
  };

  return {
    recipientOptions: recipientOptions.filter(filterOptions),
    triggerOptions: getTriggerOptions(recipient).filter(filterOptions),
  };
};
